import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { ICreateWorkTimeDto, IWorkTime } from '../interface/workTimes';
import { useAnalytics } from './useAnalytics';
import { AnalyticsFeatureOperation } from '../interface/analytics';

const createWorktime = async (params: ICreateWorkTimeDto): Promise<IWorkTime> => {
  return post(API_URLS.WORK_TIMES, params);
};

export const useCreateWorktime = (): UseMutationResult<
  IWorkTime,
  AxiosError<{ message?: string; type?: string }>,
  ICreateWorkTimeDto
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: createWorktime,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.WORKTIME_CREATED);
      showToast('success', t('worktime:workTimeCreated'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
